<script>
  export let data

  /** @type {?import('./$types').ActionData} */
  export let form = null

  import { browser } from "$app/environment"
  import { goto } from "$app/navigation"
  import { page } from "$app/stores"

  import WarpcastSignupDialog from "$lib/components/dialog/account/warpcast-signup-dialog.svelte"
  import Button from "$lib/components/ui/button.svelte"
  import Landing from "$lib/components/ui/landing.svelte"
  import { Crisp, identify } from "$lib/services/logging.js"
  import profile from "$lib/stores/profile.js"
  import alerts from "$lib/stores/snackbar"

  /** @type {import("$lib/components/dialog/account/warpcast-signup-dialog.svelte").default} */
  let warpcastSignupDialog

  // Handling to fix mangling email through URL + mailgun
  let email = $page.url.searchParams.get("email") ?? ""
  email = email.replaceAll(" ", "+")

  const loginModel = {
    email,
    remember: false,
  }

  $: {
    if (browser && form?.success && form.data?.email) {
      const environment = []
      if ($page.data.appEnvironment) {
        environment.push(`env-${$page.data.appEnvironment}`)
      }
      Crisp.session.setSegments([ "hub", ...environment ], false)

      profile.update({ email: form?.data.email })
      identify()
    }
  }

  $: properties = $page.url.searchParams.entries()

  // eslint-disable-next-line no-unused-expressions, no-sequences
  $: $page, warpcastSignupDialog && handleWarpcastSignup()

  async function handleWarpcastSignup() {
    if ($page.url.searchParams.get("channel")) {
      warpcastSignupDialog.open()
    } else if ($page.url.searchParams.has("warpcast")) {
      alerts.error({ message: "Warpcast connect is currently unavailable.  Please try again later" })
      $page.url.searchParams.delete("warpcast")
      goto($page.url)
    }
  }
</script>

<Landing>
  <svelte:fragment slot="content">
    <div class="sm:mx-auto sm:w-full sm:max-w-md mb-8">
      {#if !form?.success}
        <h2 class="mt-6 text-center text-3xl font-semibold text-gray-900">Log in to your account</h2>
      {:else}
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">Check your email</h2>
      {/if}
    </div>

    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white px-4 sm:px-2 gap-4 flex flex-col">
        {#if !form?.success}
          <form method="GET">
            <input type="hidden" name="warpcast" value="" />
            {#each properties as [ key, value ]}
              <input type="hidden" name={key} value={value} />
            {/each}
            <Button type="submit" variant="outlined" class="w-full text-sm font-medium px-2.5 flex items-center gap-2">
              <img class="w-6 h-6" src="https://assets.getpercs.com/hub/integration-warpcast-logo.svg" alt="warpcast logo" />
              Sign in with Warpcast
            </Button>
          </form>
          <div class="py-2 flex flex-row items-center gap-2">
            <hr class="w-full" />
            <span class="flex-none text-[#828282]">or</span>
            <hr class="w-full" />
          </div>
          <form method="POST" action="?{$page.url.searchParams}">
            <label class="block text-gray-700 text-sm font-medium mb-2" for="email">
              Email
            </label>
            <input
              id="email" type="email" autocomplete="email" name="email" bind:value={loginModel.email} required
              class="shadow appearance-none border border-gray-300 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
            />

            <Button type="submit" class="w-full text-sm font-medium px-2.5">
              Sign in
            </Button>
          </form>
          <div class="flex justify-center w-auto">
            Don’t have an account?
            <a href="/account/signup{$page.url.search}" class="pl-1 font-semibold">
              Sign up
            </a>
          </div>
        {:else}
          <div class="flex flex-col items-center">
            <div class="mt-6 ">
              <p class="text-center text-gray-600">We sent a verification link to</p>
              <p class="text-center font-semibold text-gray-700">
                {form?.data.email}.
              </p>

              <button class="flex justify-center items-center text-sm text-center text-gray-600 mt-8 mx-auto cursor-pointer"
                on:click={() => {
                  loginModel.email = ""
                  history.back()
                }} >
                <div>
                  <!-- Heroicon name: arrow-left -->
                  <svg width="18" height="14" class="mr-1" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.75 13.25L1.5 7M1.5 7L7.75 0.75M1.5 7H16.5" stroke="#285FE0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="mt-1 text-blue-700 flex gap-2 transition-colors duration-300 focus:text-blue-500 hover:text-blue-500">
                  Go back
                </div>
              </button>
            </div>
          </div>
        {/if}
      </div>
    </div>
  </svelte:fragment>
</Landing>

<WarpcastSignupDialog bind:this={warpcastSignupDialog} url={data.connectUrl}>
  {#if data.connectQrCodeSvg}
    {@html data.connectQrCodeSvg}
  {/if}
</WarpcastSignupDialog>
